import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import InputTableRow from '../../../inputTableRow';
import useRowRef from './hooks/useRowRef';
function VirtualizedInputTableRow(props) {
  var data = props.data,
    rowIndex = props.index,
    style = props.style;
  var _data$errors = data.errors,
    errors = _data$errors === void 0 ? EMPTY_ARRAY : _data$errors,
    columns = data.columns,
    getTdProps = data.getTdProps,
    onAction = data.onAction,
    rowStyle = data.rowStyle,
    highlightRowOnFocus = data.highlightRowOnFocus,
    _data$list = data.list,
    list = _data$list === void 0 ? EMPTY_ARRAY : _data$list,
    setRowHeight = data.setRowHeight;
  var rowData = list[rowIndex];
  var rowError = errors[rowIndex];
  var rowRef = useRowRef(rowData, rowIndex, setRowHeight);
  return /*#__PURE__*/React.createElement("div", {
    style: style
  }, /*#__PURE__*/React.createElement(InputTableRow, {
    rowIndex: rowIndex,
    rowData: rowData,
    columns: columns,
    getTdProps: getTdProps,
    onAction: onAction,
    errors: rowError,
    rowStyle: _objectSpread(_objectSpread({}, rowStyle), {}, {
      minWidth: 'fit-content'
    }),
    highlightRowOnFocus: highlightRowOnFocus,
    rowRef: rowRef
  }));
}
VirtualizedInputTableRow.propTypes = {
  data: PropTypes.shape({
    list: PropTypes.array,
    errors: PropTypes.array,
    columns: PropTypes.array,
    getTdProps: PropTypes.func,
    onAction: PropTypes.func,
    rowStyle: PropTypes.object,
    highlightRowOnFocus: PropTypes.bool,
    setRowHeight: PropTypes.func
  }),
  index: PropTypes.number.isRequired,
  style: PropTypes.object
};
VirtualizedInputTableRow.defaultProps = {
  data: EMPTY_OBJECT,
  style: EMPTY_OBJECT
};
export default /*#__PURE__*/React.memo(VirtualizedInputTableRow);